import { render } from "./TarotDetailScreenShots.vue?vue&type=template&id=3d1213c1&scoped=true"
import script from "./TarotDetailScreenShots.vue?vue&type=script&lang=js"
export * from "./TarotDetailScreenShots.vue?vue&type=script&lang=js"

import "./TarotDetailScreenShots.vue?vue&type=style&index=0&id=3d1213c1&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d1213c1"]])

export default __exports__